import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

// Line-by-line masked text reveal. Pass an array of strings as `lines`.
export const MaskText = ({ lines, className = "", delay = 0 }) => {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="reveal-mask">
          <motion.span
            style={{ display: "block" }}
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1, ease: EASE, delay: delay + i * 0.12 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

// Scroll-triggered fade-up wrapper
export const FadeUp = ({ children, delay = 0, y = 32, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease: EASE, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

// Centered editorial section heading with gold underline divider (matches reference)
export const SectionHeading = ({ eyebrow, title, dark = false, center = true, className = "" }) => (
  <FadeUp className={`${center ? "text-center" : ""} ${className}`}>
    {eyebrow && <p className="eyebrow mb-5">{eyebrow}</p>}
    <h2
      className={`font-serif text-3xl md:text-5xl tracking-tight leading-tight ${
        dark ? "text-[#f4f2ec]" : "text-[#ece0cd]"
      }`}
    >
      {title}
    </h2>
    <span className={`block w-16 h-px bg-gold mt-6 ${center ? "mx-auto" : ""}`} />
  </FadeUp>
);

export { EASE };
